import { format } from 'date-fns';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend dayjs with UTC and timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Formats a UTC date string to local time in readable format
 * Assumes the backend sends dates in UTC format
 * @param {string} dateString - The UTC date string to format
 * @returns {string} Formatted date string in local timezone or 'N/A' if invalid
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';

  try {
    // Debug: log the incoming date string to see what format we're receiving
    console.log('Formatting date:', dateString);

    // Parse the date as UTC and convert to local timezone
    const localDate = dayjs.utc(dateString).local();

    // Debug: log the converted date
    console.log('Converted to local:', localDate.format('DD/MM/YYYY HH:mm:ss Z'));

    return localDate.format('DD/MM/YYYY HH:mm');
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
};

/**
 * Formats a UTC date string to show only the date in local timezone
 * @param {string} dateString - The UTC date string to format
 * @returns {string} Formatted date string in local timezone or 'N/A' if invalid
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return 'N/A';

  try {
    // Parse the date as UTC and convert to local timezone
    const localDate = dayjs.utc(dateString).local();
    return localDate.format('DD/MM/YYYY');
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
};

/**
 * Converts a local date to UTC ISO string for sending to backend
 * @param {Date|string|dayjs.Dayjs} date - The local date to convert
 * @returns {string} UTC ISO string
 */
export const toUTC = (date) => {
  if (!date) return null;
  return dayjs(date).utc().format();
};

/**
 * Gets current UTC timestamp as ISO string
 * @returns {string} Current UTC timestamp
 */
export const nowUTC = () => {
  return dayjs().utc().format();
}; 